import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import {
  confirmToast,
  images,
  notifyDanger,
  notifySuccess,
} from "../../actions/customFn";
import axios from "../../api/axios";

const ModuleReport = ({ id }) => {
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);

  useEffect(() => {
    if (!id) return;
    getModuleReport();
  }, [id]);

  async function getModuleReport() {
    try {
      setLoading(true);
      const url = `/dashboard-data/get-batch-report`;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
        },
      };
      const data = {
        batchId: id,
      };
      const response = await axios.post(url, data, config);

      if (response.status === 200) {
        notifySuccess("Data received");
        setReportData(response.data.data);
      }
    } catch (error) {
      console.log(error);
      notifyDanger(error.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "rgb(23, 23, 23)",
        borderRadius: "8px",
        color: "white",
      }}
    >
      <div
        style={{
          overflowX: "auto",
          maxHeight: "400px",
          border: "1px solid #10b981",
          borderRadius: "6px",
          backgroundColor: "#171717",
        }}
      >
        {loading ? (
          <p style={{ padding: "10px" }}>Loading...</p>
        ) : reportData && reportData.length > 0 ? (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#10b981" }}>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Submitted</th>
                <th style={thStyle}>Total</th>
              </tr>
            </thead>
            <tbody>
              {reportData.map((student) => (
                <tr key={student.studentId}>
                  <td style={tdStyle}>{student.studentName}</td>
                  <td style={tdStyle}>{student.studentEmail}</td>
                  <td style={tdStyle}>{student.submitted}</td>
                  <td style={tdStyle}>{student.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={{ padding: "10px" }}>No Data Found</p>
        )}
      </div>
    </div>
  );
};

// Reusable styles
const thStyle = {
  padding: "10px",
  borderBottom: "1px solid #10b981",
  fontWeight: "600",
};

const tdStyle = {
  padding: "10px",
  borderBottom: "1px solid #10b981",
};

export default ModuleReport;